var siteAnnouncement = function () {
    var root = document.documentElement;

    var hideAnnouncement = (getCookie('bs_announcementBar')) ? getCookie('bs_announcementBar') : false;
    var hideAnnouncementBtn = document.querySelector('.site-notification-bar [data-toggle="disclosure"]');

    if(hideAnnouncementBtn) {
        var toggleID = hideAnnouncementBtn.getAttribute('aria-controls');
        var toggleTarget = document.getElementById(toggleID);

        hideAnnouncementBtn.addEventListener('close', function () {
            setCookie('bs_announcementBar', true, 1, '/');
            root.style.removeProperty('--bs-header-height');
        });

        if(!hideAnnouncement) {
            var siteAnnouncementBar = document.querySelector('.wp-block-bluebear-site-announcement');
            var siteNavBar = document.querySelector('.site-navigation');

            toggleTarget.classList.add('disclosure-show');
            toggleTarget.classList.remove('disclosure-hide');

            var site_header_height = siteAnnouncementBar.offsetHeight + siteNavBar.offsetHeight;

            //set css var for header height adjustment
            root.style.setProperty('--bs-header-height', site_header_height + "px");
        }
        else {
            hideAnnouncementBtn.setAttribute('aria-expanded', 'false');
            root.style.removeProperty('--bs-header-height');
            toggleTarget.classList.add('disclosure-hide');
            toggleTarget.classList.remove('disclosure-show');
        }
    }
};

//set and get cookie information
var setCookie  = function(cname, cvalue, exdays, path) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + "; path=" + path;
};

var getCookie = function(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
        }
    }
    return "";
}
siteAnnouncement();